/**
 * @generated SignedSource<<e5b6341570849f1ce4c720b37df716e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BillingFrequency = "MONTHLY" | "ONE_TIME" | "YEARLY";
export type PackageBillingType = "ONE_TIME" | "SUBSCRIPTION";
import { FragmentRefs } from "relay-runtime";
export type usePackageMonthlyPrice_memberPackage$data = {
  readonly package: {
    readonly billingOptions: ReadonlyArray<{
      readonly billingCharges: ReadonlyArray<{
        readonly frequency: BillingFrequency;
        readonly squareVariation: {
          readonly amount: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
    readonly billingType: PackageBillingType;
  };
  readonly " $fragmentType": "usePackageMonthlyPrice_memberPackage";
};
export type usePackageMonthlyPrice_memberPackage$key = {
  readonly " $data"?: usePackageMonthlyPrice_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePackageMonthlyPrice_memberPackage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePackageMonthlyPrice_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billingType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingOption",
          "kind": "LinkedField",
          "name": "billingOptions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BillingCharge",
              "kind": "LinkedField",
              "name": "billingCharges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "frequency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SquareItemVariation",
                  "kind": "LinkedField",
                  "name": "squareVariation",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "amount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};

(node as any).hash = "0783c64c4646dabbab8774f854618c29";

export default node;
